module.exports = __webpack_public_path__ + "img/mini-annulled.9f0f9338.svg";